import { identifyLogRocketUser } from '@portal/common/services/logrocket';

import api from '../../api';
import {
    SESSION_ACCOUNT_LOADED,
    SESSION_ACCOUNT_PASSWORD_CHANGED,
    SESSION_ACCOUNT_UPDATED,
    SESSION_SIGNED_IN,
    SESSION_SIGNED_OUT,
} from './types';

export const signIn = (email, password) => (dispatch) =>
    api.session.signIn(email, password).then((session) => {
        api.setSessionToken(session.token);
        dispatch({
            type: SESSION_SIGNED_IN,
            payload: session,
        });

        identifyLogRocketUser(session.account.id.toString());

        return session;
    });

export const signOut = ({ error }: { error?: string } = {}) => {
    api.setSessionToken(null);
    return {
        type: SESSION_SIGNED_OUT,
        payload: { error },
    };
};

export const destroySession = signOut;

export const loadAccount = (accountId) => (dispatch) =>
    api.account.getAccount(accountId).then((account) => {
        dispatch({
            type: SESSION_ACCOUNT_LOADED,
            payload: account,
        });

        identifyLogRocketUser(account.id.toString());

        return account;
    });

export const updateAccount = (id, data) => (dispatch) => {
    return new Promise((resolve) => {
        api.admins.updateAdmin(id, data).then((account) => {
            dispatch({
                type: SESSION_ACCOUNT_UPDATED,
                payload: account,
            });
            resolve(account);
        });
    });
};

export const changeAccountPassword = (accountId, password, newPassword) => (dispatch) =>
    api.account.setPassword(accountId, password, newPassword).then((account) => {
        dispatch({
            type: SESSION_ACCOUNT_PASSWORD_CHANGED,
            payload: account,
        });
        return account;
    });
